import { window, document } from '../../helpers/BrowserHelpers';
import getSelectionRange from './getSelectionRange';

function getWindowHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

function getWindowWidth(containerBounds) {
  return containerBounds && containerBounds.width + containerBounds.left || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

function getRangeBounds() {
  var selectionRange = getSelectionRange();
  return selectionRange ? selectionRange.getClientRects()[0] : false;
}

export default function computePopoverControl(_ref) {
  var containerEl = _ref.containerEl,
      _ref$popoverMaxHeight = _ref.popoverMaxHeight,
      popoverMaxHeight = _ref$popoverMaxHeight === void 0 ? 240 : _ref$popoverMaxHeight,
      _ref$popoverMaxWidth = _ref.popoverMaxWidth,
      popoverMaxWidth = _ref$popoverMaxWidth === void 0 ? 240 : _ref$popoverMaxWidth,
      _ref$bottomSpace = _ref.bottomSpace,
      bottomSpace = _ref$bottomSpace === void 0 ? 0 : _ref$bottomSpace;
  var containerBounds = containerEl && containerEl.getBoundingClientRect();
  var rangeBounds = getRangeBounds(); // Container not yet rendered or no selection

  if (!containerBounds || !rangeBounds) {
    return false;
  }

  var padding = 4;
  var lineHeight = rangeBounds.height * 2;
  var placement = 'bottom';
  var controlLeft = rangeBounds.left - containerBounds.left;
  var controlRight = 'auto';
  var frameWidth = getWindowWidth(containerBounds); // Popover overlaps right side

  if (rangeBounds.left + popoverMaxWidth > frameWidth) {
    controlLeft = 'auto';
    controlRight = 0;
  }

  var controlTop = lineHeight + rangeBounds.top - containerBounds.top - padding;
  var controlBottom = 'auto';
  var frameHeight = getWindowHeight(); // Popover overlaps bottom side

  if (rangeBounds.top + popoverMaxHeight > frameHeight) {
    controlBottom = containerBounds.height - controlTop + lineHeight + padding + bottomSpace;
    controlTop = 'auto';
    placement = 'top';
  }

  return {
    style: {
      top: controlTop,
      right: controlRight,
      bottom: controlBottom,
      left: controlLeft
    },
    placement: placement
  };
}